export class NgxGalleryLayout {
  static ThumbnailsTop = "thumbnails-top";
  static ThumbnailsBottom = "thumbnails-bottom";
}



// WEBPACK FOOTER //
// /agir/src/app/components/ngx-gallery/ngx-gallery-layout.model.ts